import { Link } from "react-router-dom";

function formatDate(iso) {
  if (!iso) return "";
  try {
    return new Date(iso).toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  } catch {
    return "";
  }
}

export default function PostCard({ post, featured = false }) {
  if (featured) {
    return (
      <Link
        to={`/post/${post.slug}`}
        className="group block fade-rise"
        data-testid={`post-card-${post.slug}`}
      >
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-12 items-center border-b border-black/10 pb-16">
          <div className="md:col-span-7 overflow-hidden">
            {post.cover_image && (
              <img
                src={post.cover_image}
                alt={post.title}
                className="w-full h-[280px] md:h-[420px] object-cover grayscale group-hover:grayscale-0 transition-all duration-700 ease-out"
              />
            )}
          </div>
          <div className="md:col-span-5">
            <div className="text-[10px] uppercase tracking-[0.28em] text-black/50 mb-4">
              {post.category} · {formatDate(post.created_at)}
            </div>
            <h2 className="font-serif text-3xl md:text-5xl font-light leading-[1.05] tracking-tight group-hover:translate-x-1 transition-transform duration-500">
              {post.title}
            </h2>
            <p className="mt-5 text-base md:text-lg text-black/65 leading-relaxed">
              {post.excerpt}
            </p>
            <div className="mt-6 text-[11px] uppercase tracking-[0.22em] text-black/60">
              Read · {post.reading_minutes} min
            </div>
          </div>
        </div>
      </Link>
    );
  }

  return (
    <Link
      to={`/post/${post.slug}`}
      className="group block py-10 border-b border-black/10 hover:border-black/30 transition-colors fade-rise"
      data-testid={`post-card-${post.slug}`}
    >
      <div className="grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-10">
        <div className="md:col-span-3 text-[10px] uppercase tracking-[0.28em] text-black/45">
          <div>{post.category}</div>
          <div className="mt-1 text-black/40">{formatDate(post.created_at)}</div>
        </div>
        <div className="md:col-span-9">
          <h3 className="font-serif text-2xl md:text-3xl font-normal leading-tight group-hover:translate-x-1 transition-transform duration-500">
            {post.title}
          </h3>
          {post.excerpt && (
            <p className="mt-3 text-base text-black/65 leading-relaxed max-w-2xl">
              {post.excerpt}
            </p>
          )}
          <div className="mt-4 text-[11px] uppercase tracking-[0.22em] text-black/45">
            Read · {post.reading_minutes} min
          </div>
        </div>
      </div>
    </Link>
  );
}
